import React, {Component} from 'react';
import * as R from 'ramda';
import {Modal} from 'react-bootstrap';
import BrandCampaignSelect from 'js/publisher_leads/brand_campaign_select';
import axios from 'axios';

const {urls} = window.sn;

require('scss/change_campaign_lightbox');

export default class ChangeCampaignLightbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCampaignId: null,
            fuzzySearchCampaigns: []
        };
    }

    /** load campaigns for fuzzy search boxes */
    UNSAFE_componentWillMount() {
        axios.get(urls.campaignFuzzySearchUrl).then(({data}) => {
            this.setState({
                fuzzySearchCampaigns: data
            });
        });
    }

    handleCampaignSelect = id => {
        this.setState({
            selectedCampaignId: id
        });
    };

    changeCampaign = () => {
        const {handlePostUpdate, post_id} = this.props;
        const {selectedCampaignId} = this.state;
        const url = urls.updateCampaignForPost.replace('__postId__', post_id);
        return axios.post(url, {campaign_id: selectedCampaignId}).then(() => {
            this.setState({
                selectedCampaignId: ''
            });
            handlePostUpdate();
        });
    };

    render() {
        const {show, onHide, campaign_name, ...p} = this.props;

        const {fuzzySearchCampaigns, selectedCampaignId} = this.state;

        const propsToUse = R.omit(['smart_questions'], this.props);
        propsToUse.smart_question_answer_result = true;

        return (
            <Modal {...p} show={show} onHide={onHide} ref="baseModal">
                <i className="fa fa-close lightbox__close" onClick={onHide} />
                <div id="change-campaign-header-container" className="text-center">
                    <img
                        id="change-campaign-header-icon"
                        src={require('images/icons/paper_airplane.png')}
                    />
                    <h2 id="change-campaign-header-main">Move Post</h2>
                    <div id="change-campaign-header-center"> Move FROM Campaign</div>
                    <div id="change-campaign-header-name">Campaign Name:</div>
                    <div id="change-campaign-header-sub">{campaign_name}</div>
                    <div id="change-campaign-header-center"> Move TO Campaign</div>
                    <div className="campaign-selector">
                        <BrandCampaignSelect
                            handleCampaignSelect={this.handleCampaignSelect}
                            showSubmitButton={false}
                            loadOnMount={false}
                            campaigns={fuzzySearchCampaigns}
                        />
                    </div>
                    <button
                        disabled={!selectedCampaignId}
                        className="btn btn-success move-post"
                        onClick={this.changeCampaign}
                    >
                        MOVE POST
                    </button>
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./components/change_campaign_lightbox.js